import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import data from "../../../../Json/Language/English";
import hindiDatas from "../../../../Json/Language/Hinid";

import { useNavigate } from "react-router-dom";
import HeadingComp from "../UdsEmployeeDashboard/CustomHooks/HeadingComp";
import useLanguageSelector from "../UdsEmployeeDashboard/CustomHooks/useLanguageSelector";
import PermissionPopup from "./PermissionPopup";
import ReactTable from "../../../AppComponent/Table";
import AttendanceCard from "../UdsEmployeeDashboard/AttendanceCard";
import _, { values } from "lodash";
import { settheOvertimeRegulrizationActions } from "../../../../Redux/Slice";
// import AttendanceTable from "../../Appcomponent/AttendanceTable";
import approved from "../../../../Assets/MainComponent/approved.svg";
import declined from "../../../../Assets/MainComponent/decline.svg";
import pending from "../../../../Assets/MainComponent/pending.svg";
import OvertimeReuqestEmp from "./OvertimeReuqestEmp";
import BackImage from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";


function OverTimeRegularizationget() {
  const EnglishData = data;
  const HindiData = hindiDatas;
  const hindiApplyLeave = HindiData;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state)
  const [languageFeed, setLanguageFeed] = useState({});
  const [createEditPopup, setCreateEditPopup] = useState(false);
  const [editPayload, setEditPayload] = useState({});
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [sno, setsno] = useState(0);

  const FileterState = {
    status: ""
  }
  const [selectVal, SetSelectval] = useState(FileterState);
  const [OptionValues, setOptionvalues] = useState([{ value: "", label: "All" }])

  const options = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "decline", label: "Rejected" },
    { value: "approved", label: "Approved" },
  ];
  const [search, setsearch] = useState("")


  const language = useSelector(
    (state) => state.laguagefoetheemployees.COuntsForLanguage
  );
  // const englishApplyLeave = EnglishData.Home.ApplyLeaveCard.Apply[0];
  const englishApplyLeave = EnglishData;

  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );

  const [leaveState, setLeaveStatus] = useState({
    pending_leave: "",
    total_leave: "",
    leave_valid_until: "",
  });
  useEffect(() => {
    const payload = {
        page_size: 10,
        page: dtpageindex,
        status: selectVal.status,
        search: search,
        request_type:"over_time",
        user:state.SideBarFiles.UserIDsemp
    };
    dispatch(settheOvertimeRegulrizationActions(payload));
    // dispatch(SetLeaveTypeDataActions(payload));
  }, [dtpageindex, selectVal,search]);
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  useEffect(() => {
    if (language == 1) {
      setLanguageFeed(EnglishData.permission);
    } else if (language == 2) {
      setLanguageFeed(HindiData);
    }
  }, [language]);

  const dispatchApiCall = (payload) => {
    // dispatch(SetTheAttendancePermissionDatasActions(payload));
  };

  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage)
  }

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const ClearState = (counts) => {
    setOptionvalues({ value: "", label: "All" })
    SetSelectval({
      ...selectVal,
      status: "",

    });
  };

  const count = (Counts, values, sel, SelectedValues) => {
    setOptionvalues(SelectedValues)
    SetSelectval({
      ///Completed
      ...selectVal,
      status: SelectedValues.value
    });
  };

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);

  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const columns =
  useMemo(
    () => [
      {
        Header: "S.NO",
        accessor: "",
        Cell: (row) => {
          console.log(row.row);
          console.log(sno);
          return <p>{Number(sno + row.row.index + 1)}</p>;
        },
      },
    {
      Header: "NOTES",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div>
              {row.row.original.remarks != null &&
                row.row.original.remarks != "" ? (
                <span >
                  {row.row.original.remarks}
                </span>
              ) : (
                <span>{"---"} </span>
              )}
            </div>
          </>
        );
      },
    },
    // {
    //   Header: "FROMTIMEzx - TOTIME",
    //   accessor: "",
    //   Cell: (row) => {
    //     const formatTime = (time) => {
    //       if (!time) return "---";
    //       const date = new Date(`1970-01-01T${time}Z`);
    //       return date.toLocaleTimeString([], {
    //         hour: '2-digit',
    //         minute: '2-digit',
    //         hour12: true,
    //       });
    //     };

    //     return (
    //       <>
    //         <div>
    //           {row.row.original.from_time ? (
    //             <span style={{ color: "#F16039" }}>
    //               {formatTime(row.row.original.from_time)} to{" "}
    //               {row.row.original.to_time ? formatTime(row.row.original.to_time) : "-"}
    //             </span>
    //           ) : (
    //             <span>{"---"} </span>
    //           )}
    //         </div>
    //       </>
    //     );
    //   },
    // },
    {
      Header: "FROMTIME - TOTIME",
      accessor: "",
      Cell: (row) => {
        const formatTime = (time) => {
          if (!time) return "---"; // Handle empty or null time
          try {
            const date = new Date(`1970-01-01T${time}Z`);
            if (isNaN(date.getTime())) throw new Error("Invalid time"); // Check for invalid date
            return date.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            });
          } catch {
            return "Invalid Time"; // Return 'Invalid Time' for errors
          }
        };
    
        return (
          <>
            <div>
              {row.row.original.from_time ? (
                <span style={{ color: "#F16039" }}>
                  {formatTime(row.row.original.from_time)} to{" "}
                  {row.row.original.to_time ? formatTime(row.row.original.to_time) : "---"}
                </span>
              ) : (
                <span>{"---"} </span>
              )}
            </div>
          </>
        );
      },
    },    
    {
      Header: "APPLIED DATE",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${row.row.original.created_at.slice(0, 10) + "  " + formattedTime
                }`}
            </span>
          </>
        );
      },
    },
    {
      Header: "STATUS",
      accessor: "",
      Cell: (row) => {
        const originalString = row.row.original.status;
        const capitalizedString = capitalizeFirstLetter(originalString);

        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                <img
                  src={
                    row.row.original.status == "approved"
                      ? approved
                      : row.row.original.status === "pending"
                        ? pending
                        : declined
                  }
                  alt="img"
                  width={"25px"}
                  height={"25px"}
                />
                &nbsp;
                <span>
                  {row.row.original.status == "approved"
                    ? "Approved"
                    : row.row.original.status === "pending"
                      ? "Pending"
                      : "Decline"}
                </span>
              </>
            ) : (

              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
  ], [sno]
);


  


  return (
    <div className={stateDisplay ? "outterContent" : "inner-Content"}>
      <div className="leaveWrapper">
                <div className="row ButtonPrevious Filters"
          style={{
            padding: "4px 4px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               

            marginLeft: "0px",
            marginRight: "0px",
          }}>
                                    <div className="col-12 leaveHeading text-left">
                            <h3>OVERTIME REGULARIZATION
                            </h3>
                        </div>

          <div className="col">
            <button
              className="btn BackImga"
              onClick={(e) => {
                if(state.SideBarFiles.SideBarFile == "ATTENDANCE"){ 
                navigate("/customattendace");
                }
                 else {
                    navigate("/empattendance");

                 }
            }}
            >
              <img className="PreviousPages" src={BackImage} />
              <span></span>

            </button>
          </div>
          <div className="col leaveButton">
            <button
              className="ButtonCSS"
              onClick={() => {
                // navigate("/permission_apply");
                setCreateEditPopup(true);
              }}
              style={{ marginBottom: "20px", background: "#234492 " }}
            >
                                {useLanguageSelector(
                                    EnglishData.Overtime_regular.applyButton,
                                    HindiData.Overtime_regular.applyButton
                                )}
            </button>
          </div>

</div>
         
          <div className="col-12 leaveSubHeading">


            <ReactTable
              data={state.Overtime_RegularizationCallEmp.overtimeRegularizationEmp}
              datacount={10}
              columns={columns}
              pagesize={pagesize}
              dtpagesize={20}
              dtpageindex={dtpageindex}
              pageindex={pageindex}
              Search={true}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}

              Filter={true}
              values={OptionValues}
              options={options}
              count={count}
              ClearState={ClearState}
              onChange={tochange}
              setsno={setsno}
              sno={sno}
              id={"spe"}
            />
          </div>
      
          <OvertimeReuqestEmp
            show={createEditPopup}
            setShow={setCreateEditPopup}
            editPayload={editPayload}
            setEditPayload={setEditPayload}
            PageIndex={dtpageindex}
                                status={selectVal.status}
                                search={search}
          />
        </div>
    </div>
  );
}

export default OverTimeRegularizationget;